import { useEffect, useState } from "react";
import { masterFetch } from "./masterApi";
import MasterLayout from "./MasterLayout";

export default function MasterDashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    masterFetch("/dashboard").then(setData).catch((e) => setErr(e.message));
  }, []);

  return (
    <MasterLayout>
      <h1 style={{ margin: "0 0 4px", fontSize: 26, letterSpacing: -0.5 }}>Dashboard</h1>
      <div style={{ opacity: 0.55, fontSize: 13, marginBottom: 28 }}>
        Platform-wide view of all tenants.
      </div>

      {err && <ErrorBox msg={err} />}

      {data && (
        <>
          <div data-testid="master-stats" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 16, marginBottom: 36 }}>
            <Stat label="Tenants total" value={data.tenants.total} accent="#8b5cf6" />
            <Stat label="Active" value={data.tenants.active} accent="#10b981" />
            <Stat label="Frozen" value={data.tenants.frozen} accent="#f59e0b" />
            <Stat label="Deactivated" value={data.tenants.deactivated} accent="#ef4444" />
          </div>

          <h2 style={{ fontSize: 14, letterSpacing: 2, opacity: 0.6, margin: "0 0 12px" }}>RECENT ACTIONS</h2>
          <div data-testid="master-recent" style={{ background: "#0f0a1c", border: "1px solid #1f1232", borderRadius: 12, overflow: "hidden" }}>
            {(data.recent_actions || []).length === 0 ? (
              <div style={{ padding: 20, opacity: 0.4, fontSize: 13 }}>No master actions yet.</div>
            ) : (
              data.recent_actions.map((r) => (
                <div key={r.id} style={{ padding: "12px 16px", borderBottom: "1px solid #1a1029", fontSize: 13, display: "flex", gap: 16, alignItems: "center" }}>
                  <span style={{ minWidth: 130, opacity: 0.5, fontSize: 11 }}>{new Date(r.at).toLocaleString()}</span>
                  <span style={{ color: "#a855f7", fontWeight: 500 }}>{r.action}</span>
                  <span style={{ opacity: 0.5, fontSize: 12 }}>{r.tenant_id?.slice(0, 8)}</span>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </MasterLayout>
  );
}

function Stat({ label, value, accent }) {
  return (
    <div style={{ background: "#0f0a1c", border: "1px solid #1f1232", padding: 18, borderRadius: 12 }}>
      <div style={{ fontSize: 11, letterSpacing: 2, opacity: 0.5, marginBottom: 6 }}>{label.toUpperCase()}</div>
      <div style={{ fontSize: 30, fontWeight: 700, color: accent }}>{value}</div>
    </div>
  );
}

function ErrorBox({ msg }) {
  return <div style={{ padding: 14, background: "rgba(255,80,90,0.1)", border: "1px solid rgba(255,80,90,0.4)", color: "#ff7886", borderRadius: 8, fontSize: 13 }}>{msg}</div>;
}
